module.exports = __webpack_public_path__ + "assets/media/dataDefaultIcon.c02b9cae.svg";